import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { ISiteNameWithId } from '../types/ISiteNameWithId';
import { ICustomViewUsageInfo } from '../types/IUsageInfo';
import { IUser } from '../types/IUser';
import { ICustomView } from './ICustomView';

export interface IGetCustomizedViewsResult extends IGetItemsResult {
    customViews: ICustomView[];
    maxStats: ICustomViewUsageInfo;
    sites: ISiteNameWithId[];
    users: IUser[];
}

export class GetCustomizedViewsRequest extends Request<IGetItemsParams, IGetCustomizedViewsResult> {
    constructor(params: IGetItemsParams) {
      super('getCustomizedViews', params);
    }
  }
